<template>
  <div class="view__view view-name">
    <div class="view__headline">
      <span class="heading beta -color-white">Wie ist Ihr Name?</span>
    </div>
    <div class="view__form form">
      <div class="field__wrap l-2col-b1-50-50">
        <div class="col col-one">
          <TextInput identifier="firstname" placeholder="Vorname" :value="user.firstname"
                     @update="user.firstname = $event"></TextInput>
        </div>
        <div class="col col-two">
           <TextInput identifier="lastname" placeholder="Nachname" :value="user.lastname"
                      @update="user.lastname = $event"></TextInput>
        </div>
      </div>
    </div>
    <div class="cta-wrapper">
      <button class="-btn-beta" @click="handleSubmit"><span>Weiter zur Anschrift</span></button>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/Input/TextInput.vue';
import { useUserStore } from '@/stores/user';
import { useViewStore } from '@/stores/view';

export default {
  name: 'NameEntry',
  components: { TextInput },
  methods: {
    handleSubmit() {
      if (this.user.firstname && this.user.lastname) {
        this.view.update('AddressEntry', this.view.counter + 1);
      }
    },
  },
  setup() {
    const user = useUserStore();
    const view = useViewStore();
    return {
      user,
      view,
    };
  },
};
</script>
